<template>
  <div>
    <div>
      <img src="@/assets/images/aboutus.png" alt="" style="width:100%" />
    </div>
    <div class="tops">
      <img src="@/assets/images/aboutfrom.png" alt="" />
    </div>
    <div class="middles">
      <div class="middles-top">
        <p class="middles-font">
          成都融畅易和科技有限公司成立于2015年，位于四川省成都经济技术开发区（龙泉驿区）南二路309号鼎峰动力港。<br /><br />
          公司是专业服务于汽车企业和开设汽车专业的中高职职业院校、应用型本科院校的科技公司，拥有庞大的汽车技术和汽车职教专家团队。<br /><br />
          公司专注于在汽车行业相关领域内的产品开发，在软件方面：公司目前主要开发了三大类产品：一、3D交互仿真类产品【含桌面客户端、VR端、WEB端】，此类产品涵盖了智能网联汽车、新能源纯电动汽车和传统燃油汽车，包含结构与原理、拆装、检测与维修、汽车总装等产品；二、资源类产品，主要涵盖课程资源、1+X认证资源、模型资源、实训资源、岗位知识体系、岗位技能体系。每个产品可自成体系，也可相互组合，形成完整资源库；三、平台类产品，主要包含课证融通在线学习平台、课证融通实训平台、人才管理系统、实训教学管理系统等，此类产品立足于学习资源的管理、学习过程管理、实训过程管理、教学过程管理即企业、院校、学生等各方的对接管理等，把培养过程与需求完整对接并实时跟踪管理。<br /><br />
          硬件产品有：汽车装调基本技能实训台、汽车冲压技能及质量检验实训台、汽车焊接技能及质量检验实训台、汽车喷涂技能及质量检验实训台、智能网联汽车实训台、线控底盘系统、线控车辆、通讯设备等等。
        </p>
        <img src="@/assets/images/companyabout.png" alt="" />
      </div>
    </div>
    <div class="bottoms">
      <img src="@/assets/images/companyint.png" alt="" />
    </div>
    <div class="bottoms-middle">
      <div class="bottoms-center">
        <img src="@/assets/images/icon-com.png" alt="" />
        <p class="bottoms-font">
          公司秉承“品质为先、服务至上、创新同行”的发展理念，<br />
          致力于促进汽车教育向学习型方向发展，并承担相应的汽车教育社会责任。
        </p>
      </div>
    </div>
    <div class="code-two">
      <div class="code-font">
        <div>
          <p>
            扫码关注<br />
            融畅易和
          </p>
          <p>成都融畅易和 科技有限公司</p>
        </div>
        <img src="@/assets/images/code.jpg" alt="" />
      </div>
    </div>
    <IndexFooter></IndexFooter>
    <work-order></work-order>
  </div>
</template>

<script>
import IndexFooter from "../components/IndexFooter.vue";
import WorkOrder from "../components/WorkOrder.vue";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  components: { IndexFooter, WorkOrder },
  methods: {},
  mounted() {},
  computed: {},
  watch: {},
};
</script>

<style lang='scss'>
.tops {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 108px;
}
.middles {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 90px;
}
.middles-top {
  width: 1240px;
  display: flex;
  justify-content: space-between;
}
.middles-font {
  width: 530px;
  height: 599px;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.bottoms {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 172px;
}
.bottoms-middle {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 31px;
}
.bottoms-center {
  width: 925px;
  display: flex;
  justify-content: space-between;
}
.bottoms-font {
  width: 726px;
  height: 64px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 42px;
  margin-top: 20px;
}
.code-two {
  width: 100%;
  display: flex;
  justify-content: center;
  .code-font {
    margin-top: 107px;
    margin-bottom: 50px;
    width: 271px;
    height: 138px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    div {
      margin-left: 30px;
      p {
        width: 85px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
      }
      p:nth-of-type(2) {
        width: 80px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin-top: 10px;
      }
    }
    img {
      width: 103px;
      height: 103px;
      margin-right: 35px;
    }
  }
}
</style>